module.exports = __webpack_public_path__ + "static/media/dog-5.afefae33.jpg";